import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareListClassicRoute: InvariantJiraRoute = {
	name: 'software-list-classic',
	path: '/jira/software/c/projects/:projectKey/list/:navigationItemId?',
};
